import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { NoteService, Store } from "@viewer/core";
import { TranslatePipe } from "@ngx-translate/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NotesFilterPipe } from "@viewer/core/pipe/notes-filter.pipe";
import { NotesFilterMode } from "@orion2/models/enums";

/**
 * This class is to display the small bubble (on IPC for example).
 * This bubble is for opening the notes and comments drawer.
 * Previously, it was only for the notes, thus the name being "notes-button".
 */
@Component({
  selector: "o-notes-button",
  imports: [
    CommonModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslatePipe,
    NotesFilterPipe
  ],
  templateUrl: "./notes-button.component.html",
  styleUrls: ["./notes-button.component.scss"]
})
export class NotesButtonComponent {
  public readonly store = inject(Store);
  private readonly noteService = inject(NoteService);
  private readonly router = inject(Router);

  public readonly hasNoteWarnings = this.noteService.hasNoteWarnings;
  public readonly printPdf = this.router.url.includes("/print");
  public readonly notesFilterMode = NotesFilterMode;
}
